import { colors, elevation, typography } from '@atlaskit/theme';

const theme = {
  colors,
  elevation,
  typography,
};

export default theme;
